import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import InvalidationTypeService from "../../services/catalog/InvalidationTypeService";
import { loadingInvalidationTypeDropdown } from "../../store/slices/invalidationTypes/invalidationTypeSlice";

export const useInvalidationType = () => {
  const dispatch: AppDispatch = useDispatch();

  const { invalidationTypeDropdown } = useSelector(
    (state: RootState) => state.invalidationType
  );

  const fetchInvalidationTypeDropdown = async () => {
    try {
      const response = await InvalidationTypeService.fetchDropdown();
      dispatch(loadingInvalidationTypeDropdown(response));
    } catch (error) {
      console.error("Error al cargar invalidation types:", error);
    }
  };

  return {
    invalidationTypeDropdown,
    fetchInvalidationTypeDropdown,
  };
};
